// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5fu7Q","footer":"styles_footer__Z40Mu","passCodeTooltip":"styles_passCodeTooltip__1T-jV"};